import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function PeterBush() {
  const peterBushSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Peter Bush",
    "jobTitle": "Chief Executive Officer",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/peter-bush"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Peter Bush - Chief Executive Officer"
        description="With over 2 decades of senior leadership and board experience, Peter Bush is an executive, investor, mentor and director with a focus on healthcare and technology sectors."
        keywords={['Peter Bush', 'CEO', 'Healthcare Executive', 'Technology Leadership', 'Investment']}
        ogImage="/peterBush.webp"
        schema={peterBushSchema}
      />

      <div className="xl:page-width px-12 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[2rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Peter Bush</span>
          </div>
        </nav>

        <div className="flex flex-col gap-2 md:gap-4 pt-24">
          <div className="text-[4.8rem] font-bold leading-[5.1rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Peter Bush
          </div>
          <div className="font-syne font-bold text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Chief Executive Officer
          </div>
        </div>
      </div>

      <div className="pt-[50px] xl:pt-[90px] xl:pb-[80px] xl:page-width px-12">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/peterBush.webp" 
                alt="Peter Bush, Chief Executive Officer: Executive and Investor in Healthcare and Technology Sectors" 
                className="w-full max-w-[300px] mx-auto md:max-w-[300px] md:mx-0"
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="font-sans text-[2.1rem] leading-[3.1rem] tracking-[.042rem] text-white">
                With over 2 decades of senior leadership and board experience, Peter Bush is an executive, investor, mentor and director, with a focus on the healthcare and technology sectors.
Peter has a proven track record of driving growth, innovation, and commercialization in various public and private entities across Australia, USA, Europe, and Asia. He has extensive expertise in mergers and acquisitions, joint ventures, cross border trade, technology licensing, regulatory compliance and risk management. He is experienced in new business development, venture capital/private equity funding, and technology commercialization.
He holds a Bachelor of Commerce from Macquarie University and a Graduate Diploma in Chartered Accounting from the Institute of Chartered Accountants in Australia.
              </div>
              

            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="peter-bush" 
        basePath="/leadership" 
      />
    </div>
  );
}